export enum MailingStatuses {
  Preparing = 1,
  Shipped
}
